import {
  StupTask,
  StupTasks,
} from "../../services/ticket/get-infra-task-ticket/GetInfraTaskResponse";
import { EvntGrp } from "../../util/general-code/enums/evnt-grp";
import {
  TcktStsTypeCpntOtherStgStupTask,
  TcktStsTypeCpntPrdStupTask,
  TcktStsTypeCpntStgStupTask,
  TcktType,
  RoleType,
} from "../../util/general-code/enums/general-codes";
import { Option } from "../../util/option";
import { NecFlgCell } from "./TicketDetailPageState";

export const TEMPLATE_FILE_URL = {
  RELATED_TICKET:
    "spreadsheet-template/ticket-detail-page-infra-task-ticket.xlsx",
  DESCRIPTION_HISTORY:
    "spreadsheet-template/ticket-detail-page-revision-history.xlsx",
};

export const REQUEST_CD_TYPES = {
  TCKT_STS_TYPE_CPNT_STG_STUP_TASK: "tckt_sts_type_cpnt_stg_stup_task",
  TCKT_STS_TYPE_CPNT_OTHER_STG_STUP_TASK:
    "tckt_sts_type_cpnt_other_stg_stup_task",
  TCKT_STS_TYPE_CPNT_PRD_STUP_TASK: "tckt_sts_type_cpnt_prd_stup_task",
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
  ROLE_TYPE: "role_type",
};
export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export const getNecFlgCells = (stupTasksList: StupTasks[]) => {
  let set = new Set();
  let res: NecFlgCell = {};
  stupTasksList.forEach((stupTasks: StupTasks) => {
    stupTasks.stupTaskList.forEach((stupTask: StupTask) => {
      if (!set.has(stupTasks.stupTaskCtgryId + "-" + stupTask.stupTaskId)) {
        set.add(stupTasks.stupTaskCtgryId + "-" + stupTask.stupTaskId);
        res[stupTasks.stupTaskCtgryId + "-" + stupTask.stupTaskId] = {
          isDirty: false,
          initialValue: stupTask.necFlg,
          currentValue: "",
        };
      }
    });
  });
  return res;
};

const tcktStsTypeCpntStgStupTask: Option[] = Object.entries(
  TcktStsTypeCpntStgStupTask,
).map(([key, value]) => ({
  label: key,
  value: value,
}));

const tcktStsTypeCpntPrdStupTask: Option[] = Object.entries(
  TcktStsTypeCpntPrdStupTask,
).map(([key, value]) => ({
  label: key,
  value: value,
}));

const tcktStsTypeCpntOtherStgStupTask: Option[] = Object.entries(
  TcktStsTypeCpntOtherStgStupTask,
).map(([key, value]) => ({
  label: key,
  value: value,
}));

export const createTcktStsTypeList: (
  tcktTypeTypeCd: string,
  tcktSts: string,
) => Option[] = (tcktTypeTypeCd, tcktStsTypeCd) => {
  switch (tcktTypeTypeCd) {
    case TcktType.STAGING_COMPONENT_SETUP_TASK:
      return tcktStsTypeCpntStgStupTask;
    case TcktType.PRODUCTION_COMPONENT_SETUP_TASK:
      return tcktStsTypeCpntPrdStupTask;
    case TcktType.OTHER_STAGING_COMPONENT_SETUP_TASK:
      return tcktStsTypeCpntOtherStgStupTask;
    default:
      return [];
  }
};

// Ticket status of key in map is after update
const NEXT_EVENT: {
  [key: string]: { [key: string]: { [key: string]: string } };
} = {
  [TcktType.STAGING_COMPONENT_SETUP_TASK]: {
    [TcktStsTypeCpntStgStupTask.WAITING]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_040_001,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_040_002,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_040_003,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_040_004,
    },
    [TcktStsTypeCpntStgStupTask.IN_PROGRESS]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_040_101,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_040_102,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_040_103,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_040_104,
    },
    [TcktStsTypeCpntStgStupTask.COMPLETE]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_040_201,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_040_202,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_040_203,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_040_204,
    },
    [TcktStsTypeCpntStgStupTask.CANCELLED]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_040_301,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_040_302,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_040_303,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_040_304,
    },
  },
  [TcktType.OTHER_STAGING_COMPONENT_SETUP_TASK]: {
    [TcktStsTypeCpntOtherStgStupTask.WAITING]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_050_001,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_050_002,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_050_003,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_050_004,
    },
    [TcktStsTypeCpntOtherStgStupTask.IN_PROGRESS]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_050_101,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_050_102,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_050_103,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_050_104,
    },
    [TcktStsTypeCpntOtherStgStupTask.COMPLETE]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_050_201,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_050_202,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_050_203,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_050_204,
    },
    [TcktStsTypeCpntOtherStgStupTask.CANCELLED]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_050_301,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_050_302,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_050_303,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_050_304,
    },
  },
  [TcktType.PRODUCTION_COMPONENT_SETUP_TASK]: {
    [TcktStsTypeCpntPrdStupTask.WAITING]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_060_001,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_060_002,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_060_003,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_060_004,
    },

    [TcktStsTypeCpntPrdStupTask.IN_PROGRESS]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_060_101,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_060_102,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_060_103,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_060_104,
    },
    [TcktStsTypeCpntPrdStupTask.COMPLETE]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_060_201,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_060_202,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_060_203,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_060_204,
    },
    [TcktStsTypeCpntPrdStupTask.CANCELLED]: {
      [RoleType.PIC_OF_DIP_APP]: EvntGrp.EVNT_GRP_PT_060_301,
      [RoleType.PIC_OF_DIP_INFRA]: EvntGrp.EVNT_GRP_PT_060_302,
      [RoleType.PIC_OF_COMPONENT_APP]: EvntGrp.EVNT_GRP_PT_060_303,
      [RoleType.PIC_OF_COMPONENT_INFRA]: EvntGrp.EVNT_GRP_PT_060_304,
    },
  },
};

export const nextInfraEventCode: (
  tcktTypeTypeCd: string,
  tcktStsTypeCd: string,
  roleCd: string,
) => string = (tcktTypeTypeCd, tcktStsTypeCd, roleCd) => {
  if (NEXT_EVENT[tcktTypeTypeCd] && NEXT_EVENT[tcktTypeTypeCd][tcktStsTypeCd]) {
    const action = NEXT_EVENT[tcktTypeTypeCd][tcktStsTypeCd];
    if (action[roleCd]) {
      return action[roleCd];
    }
  }
  return "";
};
